<template>
  <div>
    <div class="donapp-navbar white-bg z-1">
      <div class="card-nav-tabs donapp-navbar-header flex">
        <div class="nav-tabs-navigation gradient-npo">
          <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs" data-tabs="tabs">
              <li
                v-for="item in radioFilter"
                @click="onChangeFilter(item.key, item.value)"
                :key="item.value"
                :class="{ active : filter === item.value}"
              >
                <a href data-toggle="tab">
                  {{ $t('datatables.'+item.titleKey) }}
                  <div class="ripple-container"></div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <underlined-input
          v-model="searchStr"
          :placeholder="$t('datatables.search')"
          class="header-underlined-input"
          color="grey"
          @updateValue="searchUpdate"
        />
        <donapp-button class="gradient-npo btn-sm" :text="$t('labels.refresh')" :action="refresh"/>
      </div>
    </div>
    <div :style="{ margin: '17px'}">
      <div class="card" v-for="(merchant, index) in merchants" :key="index">
        <div class="card-content">
          <div
            class="merchant-image grey-bg"
            :class="{ 'size-md-bg': !merchant.img || merchant.img.length <1 }"
            :style="{ 'background-image': 'url(' + (merchant.img || './static/shop.svg') + ')' }"
          ></div>

          <div class="merchant-container">
            <h2 class="merchant-title">{{merchant.name}}</h2>

            <div class="first-column">
              <p class="field-label">{{$t('labels.category')}}</p>
              <p class="field-value capitalize">{{ merchant.category }}</p>
              <div class="field-divider"></div>

              <p class="field-label">{{$t('labels.description')}}</p>
              <p class="field-value">{{ merchant.description }}</p>
            </div>

            <div class="second-column">
              <p class="field-label">{{$t('labels.status')}}</p>
              <p class="field-value capitalize bold">{{ merchant.refNpo ? 'Active' : 'Inactive' }}</p>
              <div class="field-divider"></div>

              <p class="field-label">{{$t('labels.raised')}}(€)</p>
              <p class="field-value capitalize bold">{{ merchant.raised }}</p>
            </div>
          </div>
        </div>
      </div>
      <infinite-loading
        spinner="spiral"
        :distance="600"
        ref="infiniteLoading"
        @infinite="infiniteHandler"
      >
        <span slot="spinner">
          <svg
            class="circle-loader"
            width="41"
            height="41"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20" cy="20" r="15"></circle>
          </svg>
        </span>
        <span slot="no-results">
          <div class="card">
            <div class="card-content">
              <div
                class="referral-program-image"
                :class="{ 'size-md-bg': !hasImg }"
                :style="{ 'background-image': 'url(' + npoImg + ')' }"
              ></div>

              <div class="referral-program-container">
                <h2 class="referral-program-title">{{ $t('npo_affiliate.title') }}</h2>
                <div class="first-column">
                  <p class="field-value capitalize">{{ $t('npo_affiliate.program') }}</p>
                  <div class="field-divider"></div>
                  <p class="field-label">{{$t('labels.description')}}</p>
                  <p
                    class="field-value"
                    :style="{ 'white-space':'pre-wrap'}"
                  >{{$t('npo_affiliate.description')}}</p>
                  <div class="field-divider"></div>
                  <p class="field-label">{{$t('npo_affiliate.duration')}}</p>
                </div>
              </div>
            </div>
          </div>
        </span>
        <span slot="no-more">
          <p class="field-label">No More</p>
        </span>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiService from '../../services/ApiService'
import InfiniteLoading from 'vue-infinite-loading'
import DonappButton from '@/components/shared/buttons/Button'
import UnderlinedInput from '@/components/shared/inputs/UnderlinedInput'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'refMerchants',
  components: {
    InfiniteLoading,
    DonappButton,
    UnderlinedInput
  },
  data() {
    return {
      merchants: [],
      page: 0,
      error: null,
      filters: {
        startDate: null,
        endDate: null,
        filters: {}
      },
      searchStr: '',
      sort: 'date',
      sortOrder: 'desc',
      filter: null,
      radioFilter: [
        {
          titleKey: 'all',
          value: null,
          key: 'status'
        },
        {
          titleKey: 'active',
          key: 'status',
          value: true
        },
        {
          titleKey: 'inactive',
          key: 'status',
          value: false
        }
      ]
    }
  },
  methods: {
    async infiniteHandler($state) {
      try {
        const { data: result } = await apiService.getRefMerchants({
          page: this.page,
          filters: JSON.stringify(this.filters)
        })
        if (result.success && result.data.results.length > 0) {
          this.page++
          this.merchants = this.merchants.concat[result.data.results]
          $state.loaded()
        } else if (!result.success) this.error = result.error.message
      } catch (error) {
        this.error = error.message
      }
      if (this.merchants.length < 20) $state.complete()
      if (this.error) this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + this.error)
    },
    refresh() {
      this.merchants = []
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      })
    },
    searchUpdate: _.debounce(function(newValue) {
      this.searchStr = newValue.toLowerCase()
      this.onChangeFilter('q', this.searchStr.trim().length > 0 ? this.searchStr.trim() : null)
    }, 300),
    onChangeFilter: function(key, value) {
      if (key === 'startDate' || key === 'endDate') value ? (value = value.toString()) : (value = null)
      if (key === 'endDate') {
        /* eslint-disable */
        value
          ? (value = moment(value)
              .add(1, 'days')
              .toString())
          : (value = null)
        /* eslint-enable */
      }

      if (key === 'startDate' || key === 'endDate' || key === 'q') this.filters = { ...this.filters, [key]: value }
      else value === null ? delete this.filters.filters[key] : (this.filters.filters[key] = value)
      this.merchants = []
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
      })
    }
  },
  computed: {
    ...mapState({
      npo: state => state.user.loggedRole.npo
    }),
    hasImg: function() {
      return this.npo.img && this.npo.img.length > 2
    },
    npoImg: function() {
      return this.hasImg ? this.npo.img : './static/img/npo.svg'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.card-content {
  text-align: left;
  padding: 17px;
  display: flex;
  // flex-direction: column;

  .referral-program-title {
    @include biggestFontSize();
    font-weight: 700;
    line-height: 21px;
    padding-left: 17px;
    flex: 0 1 100%;
    margin: 0;
  }

  .referral-program-image {
    width: 325px;
    height: 325px;
    margin-top: -34px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    @include shadow();
    @include borderRadius();
  }

  .referral-program-container {
    flex-grow: 1;
    flex: 1;
    display: flex;
    flex-flow: row wrap;
  }

  .merchant-title {
    @include biggestFontSize();
    font-weight: 700;
    letter-spacing: 1.05px;
    line-height: 21px;
    padding-bottom: 9px;
    padding-left: 17px;
    flex: 0 1 100%;
    margin: 0;
  }

  .field-label {
    color: $grey;
    padding-top: 8px;
  }
  .field-value {
    padding-bottom: 8px;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .field-divider {
    border-bottom: 1px solid #d9dadb;
  }

  .merchant-title {
    @include biggestFontSize();
    font-weight: 700;
    letter-spacing: 1.05px;
    line-height: 21px;
    padding-bottom: 9px;
    padding-left: 17px;
    flex: 0 1 100%;
    margin: 0;
  }

  .merchant-image {
    width: 325px;
    height: 325px;
    margin-top: -34px;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;

    @include shadow();
    @include borderRadius();
  }

  .merchant-container {
    flex-grow: 1;
    flex: 1;
    display: flex;
    flex-flow: row wrap;
  }

  .first-column,
  .second-column {
    padding-left: 17px;
    flex-grow: 1;
    flex: 1;
    // width: 50%;
  }

  .first-column .field-value:last-of-type {
    text-transform: initial;
  }

  .second-column .field-value {
    font-weight: 600;
  }
}

.donapp-navbar {
  display: flex;
  height: $topbarHeight;
  justify-content: space-between;
  align-items: center;
  padding: 0px 17px;
  border-radius: 0px;
  @include shadow();
}

.nav-tabs-navigation {
  border-radius: 8px;
  margin: auto 2px;
}

.card-nav-tabs.donapp-navbar-header {
  flex: 1;
}

.card-nav-tabs .nav-tabs-title {
  color: $white;
  @include normalFontSize();
  line-height: 14px;
  padding: 8px 0px;
  margin-right: 8px;
  font-weight: normal;
}

.nav-tabs > li > a,
.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
  font-weight: normal;
  text-transform: none;
  @include normalFontSize();
  line-height: 14px;
  padding: 8px $primaryDistance;
}

.header-underlined-input {
  margin: auto;
  margin-left: 20px;
  line-height: 14px;
}

.card-nav-tabs .nav-tabs {
  font-size: 14px;
  line-height: 14px;
  font-weight: normal;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background-color: rgba(255, 255, 255, 0.8);
  color: $npoStart !important;
  transition: background-color 0.1s 0.2s, color 0.1s 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/npos/RefMerchants.vue